import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { makeStyles } from '@mui/styles';
import { useState } from 'react';

import {
  ThemedCheckbox,
  ThemedPrimaryBtn,
  ThemedSecondaryBtn,
} from '@themes/defaultThemeProps';
import { useGetBaseRolesQuery } from 'api/role.api';
import commonStyle from 'assets/jss/material-dashboard-pro-react/commonStyle';

const useStyles = makeStyles((theme) => ({
  ...commonStyle,
  root: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  parameterName: {
    fontWeight: 500,
  },
  defaultLabel: {
    fontWeight: 300,
  },
}));

export default function RoleSelector(props) {
  const tenantRole = props.tenantRole;
  const { data: baseRoles } = useGetBaseRolesQuery();
  const userRoles = baseRoles.filter((role) => role.scope === props.roleScope);

  const [role, setRole] = useState(tenantRole.role);
  const [defaultEnvironment, setDefaultEnvironment] = useState(
    tenantRole.default
  );

  const classes = useStyles();

  // eslint-disable-next-line
  const handleUpdate = (e) => {
    e.preventDefault();

    const updatedTenantRole = {
      ...tenantRole,
      role: role,
      default: defaultEnvironment,
    };
    props.handleUpdate(updatedTenantRole);

    props.handleClose();
  };

  const handleSubmit = handleUpdate;

  const handleDefault = (checked) => {
    setDefaultEnvironment(checked);
  };

  const roles = () => {
    const roleList = userRoles.map((option, key) => {
      return (
        <MenuItem value={option.name} key={key}>
          {option.name}
        </MenuItem>
      );
    });
    roleList.unshift(
      <MenuItem key='Unauthorized' value='Unauthorized'>
        Unauthorized
      </MenuItem>
    );
    return roleList;
  };

  const RoleSelect = () => {
    return (
      <FormControl variant='standard' className={classes.formControl}>
        <InputLabel id='select-label' className={classes.inputLabel}>
          Role
        </InputLabel>
        <Select
          variant='standard'
          className={classes.select}
          labelId='select-label'
          id='select'
          value={role}
          onChange={(e) => setRole(e.target.value)}
        >
          {roles()}
        </Select>
      </FormControl>
    );
  };

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby='form-dialog-title'
      >
        <DialogTitle id='form-dialog-title'>
          Select Role for {tenantRole.label}
        </DialogTitle>

        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <RoleSelect />
            </Grid>
            <Grid item xs={12}>
              <FormGroup className={classes.formControl}>
                <FormControlLabel
                  control={
                    <ThemedCheckbox
                      checked={defaultEnvironment}
                      onChange={(e) => handleDefault(e.target.checked)}
                      disabled={role === 'Unauthorized'}
                    />
                  }
                  label='Default'
                />
              </FormGroup>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <ThemedSecondaryBtn onClick={props.handleClose} color='secondary'>
            Cancel
          </ThemedSecondaryBtn>
          <ThemedPrimaryBtn onClick={handleSubmit} color='primary'>
            Save
          </ThemedPrimaryBtn>
        </DialogActions>
      </Dialog>
    </div>
  );
}
